import { StatusDot } from '../../ui/StatusDot';
import { useUiStore } from '../../../store/ui.store';
import { useHealth } from '../../../hooks/useSystem';

/** API/database health from GET /health, polled once a minute. */
export function SidebarFooterStatus() {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  const { data, isError, isLoading } = useHealth();
  if (collapsed) return null;

  const ok = data?.status === 'ok';
  const tone = isLoading ? 'off' : ok ? 'ok' : isError ? 'bad' : 'warn';
  const value = isLoading ? 'กำลังตรวจสอบ…' : ok ? 'เชื่อมต่อแล้ว' : isError ? 'ติดต่อไม่ได้' : 'Database degraded';

  return (
    <div className="mt-3 border-t border-border px-2 pb-0.5 pt-3">
      <div className="flex items-center gap-1.5">
        <StatusDot tone={tone} size={6} />
        <p className="truncate text-[10.5px] text-text-secondary">
          API · <b className="text-text-primary">{value}</b>
        </p>
      </div>
      <p className="mt-1 truncate text-[9.5px] text-text-tertiary">© 2026 Multi-PERT · v0.1.0</p>
    </div>
  );
}
